import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import Input from 'src/componentes/input';
import OnboardingHeader from '../OnboardingHeader';
import OnboardingFooter from '../OnboardingFooter';

const PasswordStep = ({
  onNext,
  onBack,
  meusDados,
  currentStep,
  totalSteps,
  error,
}) => {
  const intl = useIntl();

  const [senha, setSenha] = useState('');
  const [confirmacaoSenha, setConfirmacaoSenha] = useState('');
  const [erroLocal, setErroLocal] = useState(null);

  useEffect(() => {
    if (!meusDados) return;

    setSenha(meusDados.senha || '');
    setConfirmacaoSenha(meusDados.confirmacaoSenha || '');
  }, [meusDados]);

  const handleFinish = () => {
    setErroLocal(null);

    if (senha !== confirmacaoSenha) {
      setErroLocal(error || intl.formatMessage({ id: 'senhaNaoConfere' }));
      return;
    }

    const dadosAtualizados = {
      senha,
      confirmacaoSenha,
    };

    onNext(dadosAtualizados);
  };

  const renderContent = () => (
    <>
      <h4 style={{ marginBottom: 10 }}>
        <strong>{intl.formatMessage({ id: 'ganheMaisSeguranca' })}</strong>
      </h4>

      <p style={{ color: '#6c757d', marginBottom: 24 }}>
        {intl.formatMessage({ id: 'escolhaNovaSenha' })}
      </p>
      <p style={{ color: '#6c757d', marginBottom: 8 }}>
        {intl.formatMessage({ id: 'padraoSenha' })}
      </p>

      <ul style={{ color: '#6c757d', marginBottom: 24, paddingLeft: 18 }}>
        <li>{intl.formatMessage({ id: 'label.minimoCaracteres' })}</li>
        <li>{intl.formatMessage({ id: 'label.umaMaiuscula' })}</li>
        <li>{intl.formatMessage({ id: 'label.umaMinuscula' })}</li>
        <li>{intl.formatMessage({ id: 'label.umNumero' })}</li>
        <li>{intl.formatMessage({ id: 'label.umCaractereEspecial' })}</li>
      </ul>

      <div style={{ textAlign: 'left' }}>
        <div>
          <strong>{intl.formatMessage({ id: 'label.novaSenha' })}</strong>
        </div>
        <Input
          type="password"
          autoComplete="new-password"
          label={intl.formatMessage({ id: 'label.novaSenha' })}
          placeholder={senha ? senha : intl.formatMessage({ id: 'placeholderSenha' })}
          model={{ value: senha, requestChange: setSenha }}
        />
        <div>
          <strong>
            {intl.formatMessage({ id: 'label.confirmacaoSenha' })}
          </strong>
        </div>
        <Input
          type="password"
          autoComplete="new-password"
          label={intl.formatMessage({ id: 'label.confirmacaoSenha' })}
          placeholder={confirmacaoSenha ? confirmacaoSenha : intl.formatMessage({ id: 'placeholderSenha' })}
          model={{
            value: confirmacaoSenha,
            requestChange: setConfirmacaoSenha,
          }}
        />
      </div>

      {(erroLocal || error) && (
        <div style={{ color: '#dc3545', marginTop: 8 }}>
          {erroLocal || error}
        </div>
      )}
    </>
  );

  return (
    <div
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      <OnboardingHeader currentStep={currentStep} totalSteps={totalSteps} />

      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ width: '60%', maxWidth: 600 }}>{renderContent()}</div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '60%', maxWidth: 600 }}>
          <OnboardingFooter
            isLastStep
            onBack={onBack}
            onPrimaryAction={handleFinish}
          />
        </div>
      </div>
    </div>
  );
};

export default PasswordStep;
